import React from "react";
import Alert from "../../../components/Alert";
import Button from "../../../components/Button";
import Input from "../../../components/Inputs";
import Modal from "../../../components/Modal";
import {
  actionResetPostAlertasInserirInformacao,
  actionPostAlertasInserirInformacao,
} from "../../../features/alertas/inserir-informacao/slices";
import { actionGetAlertasAbertos } from "../../../features/alertas/slices";
import transformDate from "../../../helpers/transform-date";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { toast } from "sonner";

const Actions = ({ close, confirm }) => {
  const { putAlertasReconhecer } = useAppSelector((state) => state);
  return (
    <nav className="actions">
      <Button size="sm" variant="secondary" onClick={close}>
        Fechar
      </Button>
      <Button
        size="sm"
        variant="primary"
        onClick={confirm}
        loading={putAlertasReconhecer.status === "loading"}
      >
        Confirmar
      </Button>
    </nav>
  );
};

const ModalInserirInformacao = ({ close, data }) => {
  const dispatch = useAppDispatch();
  const [state, setState] = React.useState({
    id: "",
    info: "",
  });
  const { postAlertasInserirInformacao } = useAppSelector((state) => state);
  const { id, dataEvento, dataNormalizacao, descricao, info } = data;
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const infoContainerRef = React.useRef<HTMLDivElement>(null);

  const confirm = async () => {
    if (state.info.length < 1) {
      return toast.error("Preencha o campo de informação");
    }
    if (state.info.length > 540) {
      return toast.error(
        "O campo de informação deve ter no máximo 540 caracteres",
      );
    }
    await dispatch(actionPostAlertasInserirInformacao(state));
    await dispatch(actionGetAlertasAbertos({ idLoja: data.idLoja }));
    close();
  };

  const handleClose = () => {
    dispatch(actionGetAlertasAbertos({ idLoja: data.idLoja }));
    dispatch(actionResetPostAlertasInserirInformacao());
    close();
  };

  const handleChange = ({
    target: { name, value },
  }: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    setState((prev) => ({ ...prev, id, [name]: value }));

  React.useEffect(() => {
    if (info?.length && infoContainerRef.current) {
      infoContainerRef.current.scrollTo({
        top: infoContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [info]);

  return (
    <Modal
      size="lg"
      closeAfter={5000}
      header={
        <>
          <h3 className="heading--sm">Inserir informação - Alerta {id}</h3>
          <p>
            <strong>Data evento: </strong> {transformDate(dataEvento, true)}
            {dataNormalizacao && (
              <>
                | <strong>Data Normalizado: </strong>{" "}
                {transformDate(dataNormalizacao, true)}
              </>
            )}
          </p>
          <p className="paragraph mb-10">
            <strong>Descrição:</strong> {descricao}
          </p>
        </>
      }
      actions={<Actions close={handleClose} confirm={confirm} />}
    >
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            minHeight: "900px",
          }}
        >
          <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
            <textarea
              name="info"
              onChange={handleChange}
              maxLength={540}
              value={state.info}
              placeholder="Insira a informação aqui..."
              style={{
                resize: "none",
                border: "2px solid #000",
                width: "100%",
                backgroundColor: "#f9f9f9",
                overflow: "hidden",
                height: "140px",
              }}
            ></textarea>
            <div style={{ textAlign: "right", width: "100%" }}>
              <span className="character-count">{state.info.length}/540</span>
            </div>
          </div>

          {info && (
            <div
              style={{
                width: "100%",
                marginTop: 16,
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                display: "flex",
                flexDirection: "column",
                flex: 1,
                minHeight: 0,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  marginBottom: 12,
                }}
              >
                <div
                  style={{
                    width: 4,
                    height: 20,
                    borderRadius: 4,
                    background: "linear-gradient(180deg, #4f46e5, #818cf8)",
                  }}
                />
                <span
                  style={{
                    fontSize: "0.85rem",
                    fontWeight: 700,
                    color: "#1e1b4b",
                    letterSpacing: "0.06em",
                    textTransform: "uppercase",
                  }}
                >
                  Informações
                </span>
                <span
                  style={{
                    marginLeft: "auto",
                    background: "#ede9fe",
                    color: "#4f46e5",
                    borderRadius: 20,
                    padding: "2px 10px",
                    fontSize: "0.72rem",
                    fontWeight: 600,
                  }}
                >
                  {info.length} {info.length === 1 ? "registro" : "registros"}
                </span>
              </div>

              <div
                ref={infoContainerRef}
                style={{
                  flex: 1,
                  minHeight: 0,
                  overflowY: "auto",
                  maxHeight: "60%",
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                  paddingRight: 2,
                }}
              >
                {info.length === 0 ? (
                  <p
                    style={{
                      textAlign: "center",
                      color: "#9ca3af",
                      fontSize: "0.9rem",
                      padding: "20px 0",
                    }}
                  >
                    Nenhuma informação disponível
                  </p>
                ) : (
                  info.map((item, index) => {
                    const criadoEmSplit = item.split(". Criado em: ");
                    const data = criadoEmSplit[1] ?? "";
                    const nomeInfoPart = criadoEmSplit[0] ?? item;
                    const colonIndex = nomeInfoPart.indexOf(": ");
                    const nome =
                      colonIndex !== -1
                        ? nomeInfoPart.substring(0, colonIndex)
                        : "";
                    const informacao =
                      colonIndex !== -1
                        ? nomeInfoPart.substring(colonIndex + 2)
                        : nomeInfoPart;

                    const initials = nome
                      .split(" ")
                      .slice(0, 2)
                      .map((n) => n[0])
                      .join("")
                      .toUpperCase();

                    return (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          gap: 12,
                          background: "#fafafa",
                          border: "1px solid #e5e7eb",
                          borderRadius: 10,
                          padding: "10px 14px",
                          transition:
                            "box-shadow 0.2s ease, border-color 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          (e.currentTarget as HTMLDivElement).style.boxShadow =
                            "0 4px 12px rgba(79,70,229,0.10)";
                          (
                            e.currentTarget as HTMLDivElement
                          ).style.borderColor = "#c7d2fe";
                        }}
                        onMouseLeave={(e) => {
                          (e.currentTarget as HTMLDivElement).style.boxShadow =
                            "none";
                          (
                            e.currentTarget as HTMLDivElement
                          ).style.borderColor = "#e5e7eb";
                        }}
                      >
                        <div
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                            background:
                              "linear-gradient(135deg, #4f46e5, #818cf8)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                            fontWeight: 700,
                            fontSize: "0.75rem",
                            flexShrink: 0,
                          }}
                        >
                          {initials}
                        </div>

                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: 3,
                              gap: 8,
                            }}
                          >
                            <span
                              style={{
                                fontWeight: 600,
                                fontSize: "0.82rem",
                                color: "#374151",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {nome}
                            </span>
                            <span
                              style={{
                                fontSize: "0.7rem",
                                color: "#9ca3af",
                                whiteSpace: "nowrap",
                                flexShrink: 0,
                              }}
                            >
                              🕐 {data}
                            </span>
                          </div>

                          <p
                            style={{
                              margin: 0,
                              fontSize: "0.88rem",
                              fontWeight: 700,
                              color: "#111827",
                              lineHeight: 1.5,
                              wordBreak: "break-word",
                            }}
                          >
                            {informacao}
                          </p>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ModalInserirInformacao;
